import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { utilButton } from "../../utils/utilButton";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { GridItemContainerLibrary } from "../generic/common/GridItemContainerLibrary";
import { GridItemContainerLibraryMaxLevel } from "../generic/common/GridItemContainerLibraryMaxLevel";
import { IconWithModifier } from "../generic/icon-with-modifier/IconWithModifier";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLocaValueProportional } from "../generic/text/TextLocaValueProportional";
export var GridItemLibrary = React.memo(function (_a) {
    var item = _a.item, onClick = _a.onClick, className = _a.className;
    var balancing = item.balancing, icon = item.icon, locaKey = item.locaKey, level = item.level;
    var totalLevels = balancing.level.length;
    var GridItemComponent = totalLevels === level ? GridItemContainerLibraryMaxLevel : GridItemContainerLibrary;
    var modifierIconProps = {
        icon: IdIcon.PlusResearchIcn,
        position: IdBadgePosition.BottomLeft,
        styleId: IdStyles.IconSmall,
    };
    return (React.createElement(GridItemComponent, { className: "" + className, onClick: function () { return utilButton.onClickWithSound(onClick); } },
        React.createElement("div", { className: "library-menu__research-item" },
            React.createElement("div", null,
                React.createElement(IconWithModifier, { styleId: IdStyles.IconLarge, icon: icon, modifierIconProps: modifierIconProps, tooltipLoca: locaKey })),
            React.createElement("div", { className: IdStyles.LibraryBookTextBackground + " flex flex--guts" },
                React.createElement(TextLocaValueProportional, { className: IdStyles.TextSmall, available: level, required: totalLevels })))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/library/GridItemLibrary.tsx
// module id = 2697
// module chunks = 3